import { useState, useEffect } from "react";
import { fetchEditorialPosts, fetchEditorialBySlug, type GlowPost } from "@/lib/api";

export function useEditorial() {
  const [posts, setPosts] = useState<GlowPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchEditorialPosts()
      .then((data) => { if (!cancelled) setPosts(data); })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { posts, loading, error };
}

export function useEditorialPost(slug: string) {
  const [post, setPost] = useState<GlowPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchEditorialBySlug(slug)
      .then((data) => { if (!cancelled) setPost(data); })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [slug]);

  return { post, loading, error };
}
